import styled from 'styled-components';
import { layerHPA } from '../../../../styles/commonStyles';

const GraphDisplay = () => {
  return <Wrapper></Wrapper>;
};

export default GraphDisplay;

const Wrapper = styled.div`
  width: 860px;
  height: 140px;

  border-radius: 6px;
  ${layerHPA}
`;
